export default __webpack_public_path__ + "static/media/logo-beta.456dc056.png";